// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap--CvJ9e","content":"content--1DrS5","body":"body--32nbV","navBackground":"navBackground--6iRbO"};